import React from 'react';

import { LazyWatermarkConfigurationPage } from '@confluence/site-settings/entry-points/WatermarkConfigurationPage.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminWatermarkConfigurationRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyWatermarkConfigurationPage />;

AdminWatermarkConfigurationRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'adminWatermarkConfiguration' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
